import React, { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { CheckCircle, LockSimple } from "@phosphor-icons/react";
import { api, formatApiErrorDetail } from "../lib/api";

const MSG = { expired: "This payment link has expired. Please contact the clinic for a new one.", cancelled: "This payment request has been cancelled." };

export default function PayRequest() {
  const { token } = useParams();
  const [params] = useSearchParams();
  const [r, setR] = useState(null);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    let tries = 0;
    const load = () => api.get(`/pay/${token}`).then(({ data }) => {
      setR(data);
      if (params.get("done") && data.status === "unpaid" && tries++ < 8) setTimeout(load, 2000);
    }).catch((e) => setErr(formatApiErrorDetail(e.response?.data?.detail) || e.message));
    load();
  }, [token, params]);

  const pay = async () => {
    setBusy(true);
    try { window.location.href = (await api.post(`/pay/${token}/checkout`)).data.url; } catch (e) { setErr(formatApiErrorDetail(e.response?.data?.detail) || e.message); setBusy(false); }
  };

  return (
    <div className="container-ccc py-20 max-w-xl" data-testid="pay-request-page">
      <h1 className="font-serif text-4xl">Secure payment</h1>
      {err && <p className="mt-6 text-red-700" data-testid="pay-request-error">{err}</p>}
      {r && (
        <div className="mt-6 bg-white border border-stone-200 rounded-md p-6 space-y-4">
          <p>For <b>{r.patient_name}</b></p>
          <ul className="text-sm divide-y divide-stone-200/70 border-y border-stone-200/70">
            {r.lines.map((l, i) => <li key={i} className="flex justify-between py-2"><span>{l.label}</span><span>£{(l.pence / 100).toFixed(2)}</span></li>)}
            <li className="flex justify-between py-2 font-medium"><span>Total</span><span data-testid="pay-request-total">£{(r.total / 100).toFixed(2)}</span></li>
          </ul>
          {r.note && <p className="text-sm text-ink-muted">{r.note}</p>}
          {r.status === "paid" && <p className="flex items-center gap-2 text-emerald-700 font-medium" data-testid="pay-request-paid"><CheckCircle size={22} weight="fill" /> Paid - thank you.</p>}
          {r.status === "unpaid" && (params.get("done")
            ? <p className="text-sm text-ink-muted" data-testid="pay-request-checking">Confirming your payment…</p>
            : <button type="button" onClick={pay} disabled={busy} className="btn-primary w-full justify-center inline-flex items-center gap-2 disabled:opacity-50" data-testid="pay-request-pay-btn">
                <LockSimple size={18} weight="bold" /> {busy ? "Opening secure payment…" : "Pay securely by card"}
              </button>)}
          {MSG[r.status] && <p className="text-sm" data-testid="pay-request-unavailable">{MSG[r.status]}</p>}
        </div>
      )}
      <p className="mt-4 text-xs text-ink-muted">Card payments are processed securely by Stripe for Cambridge Cardiovascular Prevention Clinic.</p>
    </div>
  );
}
